import api from '@/configs/GlobalRequestHandler.js';

export default {
  createPromotion:(promotionsBody, raffleId) => {
    return api.postRequestWithBody(`/campaigns_promotions/${raffleId}`, promotionsBody)
  },
  deletePromotion:(promotionsId) => {
    return api.deleteRequest(`/campaigns_promotions/${promotionsId}`)
  },
}